<template>
  <div class="gray-bg">
    <section
      v-if="card"
      id="carouselExampleControls"
      class="carousel slide"
      data-bs-ride="carousel"
      data-bs-touch="true"
    >
      <!-- Slide indicator dots (only shown when there's more than one image) -->
      <div class="carousel-indicators" v-if="galleryImages.length > 1">
        <button
          v-for="(img, i) in galleryImages"
          :key="'indicator-' + img.imageId"
          type="button"
          data-bs-target="#carouselExampleControls"
          :data-bs-slide-to="i"
          :class="{ active: i === 0 }"
          :aria-current="i === 0 ? 'true' : undefined"
          :aria-label="'Slide ' + (i + 1)"
        ></button>
      </div>

      <div class="carousel-inner">
        <!-- One slide per gallery image: the first is the main picture -->
        <div
          v-for="(img, i) in galleryImages"
          :key="img.imageId"
          class="carousel-item"
          :class="{ active: i === 0 }"
        >
          <ImageComponent :imageId="img.imageId"></ImageComponent>
        </div>

        <!-- Fallback to the trail's cover image when it has no gallery images -->
        <div
          v-if="galleryImages.length === 0 && card.CoverImage"
          class="carousel-item active"
        >
          <ImageComponent :imageId="card.CoverImage"></ImageComponent>
        </div>
      </div>
      <button
        v-if="galleryImages.length > 1"
        class="carousel-btn carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleControls"
        data-bs-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button
        v-if="galleryImages.length > 1"
        class="carousel-btn carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleControls"
        data-bs-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </section>

    <section v-if="card" class="full-width-image-section trail-info white-sep">
      <div class="container text-center">
        <!-- Success Banner -->
        <div v-if="showCompletionBanner" class="completion-banner">
          <p>
            Well done! You finished <br /><b>{{ card.Name }}</b>
          </p>
          <p>Would you like to share it?</p>
          <router-link
            :to="'/completedWalks'"
            class="btn btn-primary w-100"
            role="button"
          >
            My Completed Walks
          </router-link>
        </div>
      </div>
    </section>

    <section v-if="card" class="trail-info-section">
      <div class="container text-center">
        <div class="share-button-wrapper">
          <a @click.prevent="sharePage">
            <img src="/assets/img/share-alt.svg" alt="Share" />
          </a>
        </div>

        <ul class="list-table-row">
          <li :class="gradeClass(card.Grading)">
            <img src="/assets/img/trails.svg" />{{ card.Grading }}
          </li>
          <li>
            <img src="/assets/img/timer.svg" />{{ formatTime(card.Duration) }}
          </li>
          <li><img src="/assets/img/distance.svg" />{{ card.Distance }} km</li>
          <li><img src="/assets/img/loop.svg" />{{ card.ShapeName }}</li>
        </ul>
        <div class="trails-details">
          <h2 v-if="card" class="heading">{{ card.Name }}</h2>
          <h5 v-if="card" class="sub-heading">{{ card.SubName }}</h5>
          <p class="paragraph">
            {{ card.ShortDescription }}
          </p>
        </div>
      </div>
    </section>

    <section
      v-if="card"
      class="full-width-image-section gray-pattern white-sep"
    >
      <div class="container">
        <div class="total-ascent">
          <ImageComponent
            v-if="card.ElevationProfile"
            :imageId="card.ElevationProfile"
          ></ImageComponent>
        </div>

        <div class="waymarking-colour">
          <h2 class="waymarking-heading">
            Waymarking Colour
            <!--<span>{{ card.Prominence }}</span>-->
          </h2>
          <!--<img src="/img/WicklowFLags/blue-arrow.png" />-->
          <img :src="'/img/WicklowFLags/' + card.Prominence" />
        </div>

        <div class="total-ascent">
          <img v-if="card.MapImage" :src="card.MapImage" alt="map image" />
        </div>

        <div class="accordion-section">
          <div class="accordion accordion-flush" id="accordionFlushExample">
            <h2 class="accordion-heading">General Information</h2>
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingOne">
                <button
                  class="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="true"
                  aria-controls="flush-collapseOne"
                >
                  Description
                </button>
              </h2>
              <div
                id="flush-collapseOne"
                class="accordion-collapse collapse show"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample"
              >
                <div class="accordion-body">
                  <div class="panel-body">
                    <p>
                      {{ card.GeneralDescription }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingTwo">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTwo"
                  aria-expanded="false"
                  aria-controls="flush-collapseTwo"
                >
                  Dogs Allowed?
                </button>
              </h2>
              <div
                id="flush-collapseTwo"
                class="accordion-collapse collapse"
                aria-labelledby="flush-headingTwo"
                data-bs-parent="#accordionFlushExample"
              >
                <div class="accordion-body">
                  <div class="panel-body">
                    <p>
                      <span v-if="card.DogsAllowed">Yes</span>
                      <span v-else>No</span>
                      <br />
                      {{ card.DogDetails }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingThree">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseThree"
                  aria-expanded="false"
                  aria-controls="flush-collapseThree"
                >
                  Carpark
                </button>
              </h2>
              <div
                id="flush-collapseThree"
                class="accordion-collapse collapse"
                aria-labelledby="flush-headingThree"
                data-bs-parent="#accordionFlushExample"
              >
                <div class="accordion-body">
                  <div class="panel-body">
                    <p>
                      {{ card.NearestCarpark }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingFour">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFour"
                  aria-expanded="false"
                  aria-controls="flush-collapseFour"
                >
                  Safety
                </button>
              </h2>
              <div
                id="flush-collapseFour"
                class="accordion-collapse collapse"
                aria-labelledby="flush-headingFour"
                data-bs-parent="#accordionFlushExample"
              >
                <div class="accordion-body">
                  <div class="panel-body">
                    <p>
                      {{ card.Safety }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingFive">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFive"
                  aria-expanded="false"
                  aria-controls="flush-collapseFive"
                >
                  Gear
                </button>
              </h2>
              <div
                id="flush-collapseFive"
                class="accordion-collapse collapse"
                aria-labelledby="flush-headingFive"
                data-bs-parent="#accordionFlushExample"
              >
                <div class="accordion-body">
                  <div class="panel-body">
                    <p>
                      {{ card.Gear }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="info-icons-section">
          <ul class="info-icons">
            <li
              class="info-distance-white"
              @click="
                openGoogleMaps(card.StartLocationLat, card.StartLocationLng)
              "
            >
              <span><img src="/assets/img/distance-white.svg" /></span>
              Trail Head
            </li>

            <li class="info-emergency">
              <span
                class="emergency-number"
                aria-label="In an emergency, call 112"
              >
                <small>EMERGENCY</small>
                <strong>112</strong>
              </span>
              Emergency? Call 112
            </li>

            <li class="info-local-amenities">
              <span>
                <router-link
                  :to="'/services/' + card.CardId"
                  style="text-decoration: none; color: inherit"
                  @click.native="
                    saveScrollPosition('ServicesGrid', card.CardId)
                  "
                >
                  <img src="/assets/img/local-amenities.svg" />
                </router-link>
              </span>
              Local Amenities
            </li>

            <li class="info-point-of-interest">
              <span>
                <router-link
                  :to="'/pois/' + card.CardId"
                  style="text-decoration: none; color: inherit"
                  @click.native="saveScrollPosition('PoiGrid', card.CardId)"
                >
                  <img src="/assets/img/point-of-interest.svg" />
                </router-link>
              </span>
              Local POIs
            </li>
            <li class="info-video-overview">
              <span>
                <router-link
                  :to="'/video/' + card.CardId"
                  style="text-decoration: none; color: inherit"
                  :class="{ 'disabled-link': !card.VideoLink }"
                  :tabindex="card.VideoLink ? 0 : -1"
                  @click.native="saveScrollPosition('Video', card.CardId)"
                >
                  <img src="/assets/img/video-overview.svg" />
                </router-link>
              </span>
              Video Overview
            </li>
            <li class="info-report-issue">
              <span>
                <a
                  href="#"
                  style="text-decoration: none; color: inherit"
                  @click.prevent="reportIssue"
                >
                  <img src="/assets/img/report-issue.svg" />
                </a>
              </span>
              Report Issue
            </li>
          </ul>
        </div>
      </div>
    </section>

    <!-- REGISTER FOR WALKS FORM - Compoonents-->
    <UserForm />

    <section class="full-width-image-section footer green-sep"></section>
  </div>
</template>

<script>
import db from "@/db";
import LeafletMap from "@/components/LeafletMap.vue";
import ImageComponent from "@/components/ImageComponent.vue";
import ImageComponentAnimate from "@/components/ImageComponentAnimate.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { Chart, registerables } from "chart.js";
import { resolveDirective } from "vue";
import { trackInteraction } from "@/utils/tracking.js";
import { _ } from "core-js";
import UserForm from "@/components/Userform.vue";

Chart.register(...registerables);

export default {
  components: {
    VueEasyLightbox,
    LeafletMap,
    ImageComponent,
    ImageComponentAnimate,
    UserForm,
  },
  data() {
    return {
      card: null,
      showSafety: false,
      showGear: false,
      showCarPark: false,
      // Lightbox related data
      visible: false,
      index: 0,
      currentImage: "",
      registered: false,
      polyline: null,
      canShare: false,
      isResumable: false,
      canFinish: false,
      showCompletionBanner: false,
    };
  },
  created() {
    this.checkRegistrationStatus();
  },
  async mounted() {
    this.canShare = !!navigator.share;
    await this.checkStartedWalk();

    this.getData();

    await this.$nextTick(); // W
    setTimeout(() => {
      window.scrollTo(0, 500);
    }, 100); // Adjust the delay time if needed

    // Restore the scroll position if it exists
    const savedPosition = sessionStorage.getItem("scrollPosition");
    //console.log("scrlPos " + savedPosition);
    if (savedPosition) {
      // Use nextTick to ensure the DOM is fully loaded before scrolling
      this.$nextTick(() => {
        setTimeout(() => {
          window.scrollTo(0, parseInt(savedPosition, 10));
        }, 100);
        sessionStorage.removeItem("scrollPosition"); // Clean up the saved position
      });
    } else {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
    }

    console.log("Initializing popover");
    $(function () {
      $('[data-toggle="popover"]').popover();
    });
  },
  computed: {
    // All valid gallery images for this trail (first one is the main picture).
    galleryImages() {
      if (!this.card || !Array.isArray(this.card.Gallery)) return [];
      return this.card.Gallery.filter(img => img && img.imageId);
    },
    firstButtonText() {
      return this.registered
        ? "Registered for Badges  <i class='fa fa-check'></i>"
        : "Register for Badges";
    },
    secondButtonText() {
      return this.registered
        ? "Unregister for Badges"
        : "UnRegistered for Badges";
    },
    hasThirdImage() {
      return (
        this.card.Gallery &&
        this.card.Gallery.length > 2 &&
        this.card.Gallery[2].imageId
      );
    },
    hasFourthImage() {
      return (
        this.card.Gallery &&
        this.card.Gallery.length > 3 &&
        this.card.Gallery[3].imageId
      );
    },
    hasFifthImage() {
      return (
        this.card.Gallery &&
        this.card.Gallery.length > 4 &&
        this.card.Gallery[4].imageId
      );
    },
  },
  methods: {
    // The grading value doubles as the CSS class that colours the tile, so map
    // it to a known class rather than trusting the CMS string verbatim - any
    // difference in case, spacing or spelling would otherwise leave it
    // unstyled. Mirrors the normalising the grade filter does.
    gradeClass(grading) {
      const grade = String(grading ?? "")
        .trim()
        .toLowerCase();
      if (grade.startsWith("stren")) return "strenuous";
      if (grade.startsWith("mod")) return "moderate";
      if (grade.startsWith("eas")) return "easy";
      return grade;
    },
    async finished(cardId) {
      debugger;
      try {
        // Mark the walk as completed
        await db.startedWalks
          .where("CardId")
          .equals(cardId)
          .modify({ Completed: 1 });

        console.log(`Walk with CardId ${cardId} marked as completed.`);

        // Check if online and send immediately
        if (navigator.onLine) {
          await this.syncWalks(); // Try syncing immediately
        } else if ("serviceWorker" in navigator && "SyncManager" in window) {
          // Register background sync for offline mode
          const registration = await navigator.serviceWorker.ready;
          await registration.sync.register("sync-walks");
          console.log("Background sync registered for completed walks.");
        }
        //reset buttons back to default
        this.canFinish = false;
        this.isResumable = false;

        //Share
        this.showCompletionBanner = true;
      } catch (error) {
        console.error("Error finishing walk:", error);
      }
    },
    async syncWalks() {
      try {
        // Get all completed walks from IndexedDB
        const finishedWalks = await db.startedWalks
          .where("Completed")
          .equals(1)
          .toArray();

        if (finishedWalks.length === 0) {
          console.log("No walks to sync.");
          return;
        }

        // Fetch user email from IndexedDB
        const user = await db.user.get(1);
        const userEmail = user?.email || "";

        for (const walk of finishedWalks) {
          const customerId = localStorage.getItem("tenantId"); // Get customer ID
          const base64Credentials = btoa("Ian:Ennistymon1!"); // Encode credentials
          const baseURL = process.env.VUE_APP_API_BASE_URL;

          // Send a JSON object in the request body
          const requestBody = {
            cardId: walk.CardId,
            userId: userEmail,
          };

          console.log("Sending request body:", JSON.stringify(requestBody));

          const response = await fetch(
            `${baseURL}VisitorCard/SetWalkCompleted`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Basic ${base64Credentials}`,
                CustomerId: customerId, // Send customerId in headers
              },
              body: JSON.stringify(requestBody), // Send JSON properly
            }
          );

          if (response.ok) {
            console.log(`Walk with CardId ${walk.CardId} successfully synced.`);
            await db.startedWalks.where("CardId").equals(walk.CardId).delete(); // Remove synced walk
          } else {
            console.error(`Failed to sync walk with CardId ${walk.CardId}`);
          }
        }
      } catch (error) {
        console.error("Error syncing walks:", error);
      }
    },
    async checkFinish(cardId) {
      try {
        // Retrieve the walk entry from IndexedDB
        const walk = await db.startedWalks
          .where("CardId")
          .equals(cardId)
          .first();

        if (!walk) {
          console.log("No walk found for CardId:", cardId);
          return;
        }

        const walkStartTime = new Date(walk.DateTime).getTime();
        const currentTime = Date.now();

        // Calculate elapsed time in milliseconds
        const elapsedTime = currentTime - walkStartTime;

        // Convert half of the duration from minutes to milliseconds
        const halfDuration = (walk.Duration / 2) * 60 * 1000;

        // Temporarily allow finishing immediately for testing.
        this.canFinish = true;
        console.log(
          `Elapsed Time: ${elapsedTime / 1000} sec, Required: ${
            halfDuration / 1000
          } sec, Can Finish: ${this.canFinish}`
        );
      } catch (error) {
        console.error("Error checking finish condition:", error);
      }
    },
    async checkStartedWalk() {
      try {
        const oneHourAgo = new Date(Date.now() - 60 * 60 * 1000).toISOString();
        const cardId = parseInt(this.$route.params.CardId);
        // Check if this CardId exists in startedWalks and is within the last hour
        const startedWalk = await db.startedWalks
          .where("CardId")
          .equals(cardId)
          .and(walk => walk.DateTime > oneHourAgo)
          .first();

        this.isResumable = !!startedWalk; // If found, set to true

        await this.checkFinish(cardId);
      } catch (error) {
        console.error("Error checking started walks:", error);
      }
    },
    async sharePage() {
      if (navigator.share) {
        try {
          await navigator.share({
            title: document.title,
            text: "Check out Duhallow Walks",
            url: window.location.href,
          });
          console.log("Successfully shared!");
        } catch (error) {
          console.error("Error sharing:", error);
        }
      } else {
        alert("Sharing not supported on this browser.");
      }
    },
    saveScrollPosition(itemType, itemId) {
      trackInteraction(itemType, itemId);

      const scrollPosition = window.scrollY;
      sessionStorage.setItem("scrollPosition", scrollPosition);
    },
    // Opens the user's own email app (web or mobile) to report an issue,
    // pre-addressed to Duhallow with the trail name filled in.
    reportIssue() {
      const recipient = "duhallow@irdduhallow.com";
      const trailName = this.card && this.card.Name ? this.card.Name : "";
      const subject = trailName
        ? `Trail Issue Report - ${trailName}`
        : "Trail Issue Report";

      const lines = ["Issue reported via the Discover Duhallow app.", ""];
      if (trailName) {
        lines.push(`Trail: ${trailName}`);
      }
      lines.push("Please describe the issue below:");
      lines.push("");

      const body = lines.join("\n");
      window.location.href = `mailto:${recipient}?subject=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(body)}`;
    },
    async getData() {
      try {
        // Fetch card data based on the CardId parameter
        const cardId = parseInt(this.$route.params.CardId); // Convert to integer if necessary
        this.card = null;
        var cardArray = await db.cards.where("CardId").equals(cardId).toArray();
        this.card = cardArray[0];
        this.polyline = cardArray[0].Polyline;

        //this.createElevationChart();
      } catch (error) {
        console.error("Error fetching card data:", error);
      }
    },
    async checkRegistrationStatus() {
      try {
        // Fetch user details from IndexedDB
        const user = await db.user.get(1);

        // Set `registered` to `true` if user email exists
        this.registered = !!(user && user.email);
      } catch (error) {
        console.error("Error checking registration status:", error);
        this.registered = false;
      }
    },
    registerForBadges() {
      this.$router.push({
        name: "register",
        params: { CardId: this.card.CardId },
      });
    },
    unRegisterForBadges() {
      //localStorage.removeItem("userEmail");
      //this.registered = !!localStorage.getItem("userEmail");
    },
    toggleSafety() {
      this.showSafety = !this.showSafety;
    },
    toggleGear() {
      this.showGear = !this.showGear;
    },
    toggleCarPark() {
      this.showCarPark = !this.showCarPark;
    },
    openGoogleMaps(lat, lng) {
      // Construct Google Maps URL
      const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;

      // Open Google Maps URL
      window.open(googleMapsUrl, "_blank");
    },
    formatTime(minutes) {
      const days = Math.floor(minutes / 1440);
      const hours = Math.floor((minutes % 1440) / 60);
      const mins = minutes % 60;
      let formattedTime = "";

      if (days > 0) {
        formattedTime += `${days} day${days > 1 ? "s" : ""}`;
      }

      if (hours > 0) {
        if (formattedTime) formattedTime += " ";
        formattedTime += `${hours} hr${hours > 1 ? "s" : ""}`;
      }

      if (mins > 0) {
        if (formattedTime) formattedTime += " ";
        formattedTime += `${mins} min${mins > 1 ? "s" : ""}`;
      }

      return formattedTime || "0 mins";
    },
    async handleImageClick(imageId) {
      try {
        const imageUrl = await this.getImageUrl(imageId);
        console.log("Image clicked, URL:", imageUrl);
        this.currentImage = imageUrl;
        this.visible = true;
      } catch (error) {
        console.error("Failed to handle image click:", error);
      }
    },

    async getImageUrl(imageId) {
      if (!imageId) return "";
      try {
        const imageRecord = await db.images.get(imageId);
        const blobUrl = imageRecord
          ? URL.createObjectURL(imageRecord.blob)
          : "";
        console.log("Generated Blob URL:", blobUrl); // Log Blob URL to verify
        return blobUrl;
      } catch (error) {
        console.error("Failed to fetch image:", error);
        return "";
      }
    },
    goBack() {
      this.$router.go(-1); // Go back to the previous page
    },

    createElevationChart() {
      const ctx = document.getElementById("elevationChart").getContext("2d");

      // Process polyline data to get distances (in km), elevations, and total ascent
      const data = this.processPolylineData();

      const gradient = ctx.createLinearGradient(0, 0, 0, ctx.canvas.height);

      const scalingPlugin = {
        id: "dynamicScaling",
        beforeUpdate: chart => {
          const maxElevation = Math.max(...chart.data.datasets[0].data);
          chart.options.scales.y.max = Math.ceil(maxElevation * 1.1); // Set the y-axis max to slightly above the highest elevation
        },
      };

      // Add color stops for gradient transition
      gradient.addColorStop(0, "rgba(0, 20, 0, 1)"); // Dark green
      gradient.addColorStop(0.5, "rgba(0, 100, 0, 1)"); // Medium green
      gradient.addColorStop(1, "rgba(0, 255, 0, 1)"); // Light green

      // Define chart with a plugin for the light blue background
      const chart = new Chart(ctx, {
        type: "line",
        data: {
          labels: data.distances, // Distances are now in kilometers
          datasets: [
            {
              label: `Total Ascent: ${data.totalAscent} m`,
              borderColor: "rgba(255, 255, 255, 1)",
              borderWidth: 6,
              data: data.elevations,
              fill: true,
              backgroundColor: gradient,
              pointRadius: 0, // No dots on line
              tension: 0.3, // Straight or curved line (0 - 1)
            },
          ],
        },
        options: {
          plugins: {
            legend: {
              labels: {
                usePointStyle: true, // Use a point instead of the box
                pointStyle: "line", // Make the point style to be like a line
              },
            },
          },
          scales: {
            y: {
              grid: {
                display: false, // Hides the grid lines for the y-axis
              },
              title: {
                display: true,
                text: "",
              },
              min: 0, // Set minimum y-axis value
              max: 1100, // Set maximum y-axis value
            },
            x: {
              type: "linear", // Ensures the x-axis is treated as linear
              ticks: {
                stepSize: 1, // Display a tick every 0.5 km
                callback: function (value, index) {
                  const roundedValue = Math.round(value * 10) / 10; // Keep one decimal place for km
                  return `${roundedValue} km`; // Display distance in kilometers
                },
              },
              grid: {
                display: false, // Hides the grid lines for the x-axis
              },
              title: {
                display: true,
                text: "Distance (km)", // Update x-axis label to show "Distance (km)"
              },
            },
          },
        },
        plugins: [scalingPlugin],
      });

      // Now that the chart is created, update its datasets to ensure the fill is applied
      chart.update();
    },

    processPolylineData() {
      // Convert distances from meters to kilometers
      const distances = this.polyline.map(
        point => point.distanceFromStart / 1000
      );
      const elevations = this.polyline.map(point => point.height);

      // Calculate total ascent
      let totalAscent = 0;
      for (let i = 1; i < elevations.length; i++) {
        const elevationGain = elevations[i] - elevations[i - 1];
        if (elevationGain > 0) {
          totalAscent += elevationGain; // Sum only positive elevation changes
        }
      }

      return { elevations, distances, totalAscent: Math.round(totalAscent) };
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getData();
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.getData();
    next();
  },
  watch: {
    "$route.params.CardId": {
      immediate: true,
      handler() {
        this.getData();
      },
    },
  },
  activated() {
    this.getData();
  },
};
</script>
<style scoped>
.info-icons li .emergency-number {
  color: #fff;
  flex-direction: column;
  gap: 0.15em;
}

.emergency-number small {
  font-size: clamp(0.75rem, 2.5vw, 1rem);
  font-weight: 700;
  letter-spacing: 0.08em;
}

.emergency-number strong {
  font-size: clamp(3rem, 10vw, 5rem);
  line-height: 0.95;
}

.share-btn {
  width: 64px;
}

.gray-bg {
  background-color: #f2f2f2 !important;
}
div#app {
  background-color: #f2f2f2 !important;
}
.disabled-link {
  pointer-events: none;
  opacity: 0.6;
}

.badge-content {
  white-space: normal;
  word-wrap: break-word;
  text-align: right; /* Optional: Align text to the right */
  max-width: 350px; /* Optional: Set a max width for better control */
  border-radius: 4px;
  margin-bottom: 2px;
  font-size: 15px;
}

.badge-content2 {
  min-width: 180px;
  border: 1px solid #bfbcbc;
  white-space: normal;
  color: #626262;
  background-color: rgb(195 225 237 / 35%);
  word-wrap: break-word;
  text-align: left; /* Optional: Align text to the right */
  max-width: 150px; /* Optional: Set a max width for better control */
}

.color-box {
  width: 65px;
  height: 15px;
  display: inline-block;
  border: 1px solid #b9b8b8; /* Optional: Add a border for better visibility */
}

li.d-flex {
  flex-wrap: wrap;
  align-items: flex-start;
}

li.d-flex a {
  flex-shrink: 0;
  margin-right: 10px;
}

.image-wrap {
  width: 100%;
  height: 50vw;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
}

.image-wrap img {
  width: 100%;
  animation: move 40s ease;
  /* Add infinite to loop. */

  -ms-animation: move 40s ease;
  -webkit-animation: move 40s ease;

  -moz-animation: move 40s ease;
  position: absolute;
}

.badge-primary {
  color: #000;
  background-color: #fbfbfb;
  padding: 10px;
  text-align: left;
  font-weight: 200;
}

.badge-secondary {
  color: #000;
  background-color: #ffffff;
  padding: 10px;
  text-align: left;
  font-weight: 600;
}

.text-dark {
  font-weight: 400;
}

.fixed-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Always three columns */
  gap: 10px; /* Adjust the gap as needed */
  padding: 0 15px; /* Add padding to fit within the viewport */
  box-sizing: border-box; /* Ensure padding is included in the total width */
  overflow-x: hidden; /* Hide horizontal overflow */
}

.fixed-grid-item {
  width: 100%; /* Ensure the grid items take full width of the grid column */
}

.service-item {
  width: 100%; /* Ensure the service items take full width of the grid column */
  box-sizing: border-box; /* Include padding and border in the element's total width and height */

  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Add transition for hover effect */
  min-height: 180px;
}
.service-item2 {
  width: 100%; /* Ensure the service items take full width of the grid column */
  box-sizing: border-box; /* Include padding and border in the element's total width and height */
  border: 1px solid #eae4e4;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Add transition for hover effect */
  min-height: 80px;
}
.service-item2:hover {
  transform: translateY(-3px); /* Lift the box slightly */
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2); /* Increase shadow for hover effect */
}
.service-item:hover {
  transform: translateY(-3px); /* Lift the box slightly */
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2); /* Increase shadow for hover effect */
}
.service-item i {
  font-size: 2rem;
}

.service-item h5 {
  font-size: 1.25rem;
}

.service-item p {
  font-size: 1rem;
}

.card-info {
  display: flex;
  justify-content: space-around;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 80px;
}

.card-info div {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  padding: 5px 0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Add drop shadow */
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card-info div:hover {
  transform: translateY(-3px); /* Lift the box slightly */
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2); /* Increase shadow for hover effect */
}

.card-info .grade {
  background-color: #3b82f6;
}

.card-info .length {
  background-color: var(--green-color);
}

.card-info .time {
  background-color: #fbbf24;
}

.card-info .type {
  background-color: #f87171;
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Two columns */
  gap: 20px; /* Adjust the gap as needed */
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Two columns */
  gap: 20px; /* Adjust the gap as needed */
  background-color: #ffffff; /* Light background color */
  border-radius: 8px; /* Rounded corners */
  padding: 10px; /* Padding inside the grid */
}

.category-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px; /* Padding for each item */
  background-color: #ffffff; /* White background for each item */
  border-radius: 4px; /* Rounded corners for each item */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05); /* Subtle shadow for each item */
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Smooth hover effect */
}

.category-item:hover {
  transform: translateY(-3px); /* Lift the item slightly on hover */
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1); /* Increase shadow on hover */
}

.waymark {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px; /* Padding for each item */
  background-color: #ffffff; /* White background for each item */
  border-radius: 4px; /* Rounded corners for each item */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05); /* Subtle shadow for each item */
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Smooth hover effect */
}

h6 {
  font-size: 30px;
}

.actions {
  display: flex;
  justify-content: space-between;
}

.tooltip {
  position: relative;
  display: inline-block;
  margin-left: 10px;
  opacity: 1;
}

.help-icon {
  font-size: 24px;
  cursor: pointer;
  top: 10px;
  position: relative;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #838181;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 110%;
  left: 50%;
  margin-left: -250px;
  opacity: 1 !important;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.carousel {
  overflow: hidden; /* Prevent overflow */
}

/* Hero images are full-bleed, so a fixed 600px cut showed only the top ~70% of
   the photo and pushed the crop off-centre. A 2:1 ratio with object-fit keeps
   almost the whole picture in view and centres whatever has to be trimmed.
   The vh cap stops the hero swallowing the screen on large monitors. */
.carousel-item img {
  width: 100%;
  aspect-ratio: 2 / 1;
  max-height: 70vh;
  object-fit: cover;
  object-position: center;
}

@keyframes move {
  0% {
    -webkit-transform-origin: bottom left;
    -moz-transform-origin: bottom left;
    -ms-transform-origin: bottom left;
    -o-transform-origin: bottom left;
    transform-origin: bottom left;
    transform: scale(1);
    -ms-transform: scale(1);
    /* IE 9 */

    -webkit-transform: scale(1);
    /* Safari and Chrome */

    -o-transform: scale(1);
    /* Opera */

    -moz-transform: scale(1);
    /* Firefox */
  }
  100% {
    transform: scale(1.5);
    -ms-transform: scale(1.5);
    /* IE 9 */

    -webkit-transform: scale(1.5);
    /* Safari and Chrome */

    -o-transform: scale(1.5);
    /* Opera */

    -moz-transform: scale(1.5);
    /* Firefox */
  }
}

@media (min-width: 1200px) {
  .about-text {
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);
  }
}

@media (max-width: 1200px) {
  .fixed-grid {
    grid-template-columns: repeat(
      3,
      minmax(0, 1fr)
    ); /* Maintain three columns on smaller screens */
  }
  .service-item i {
    font-size: 2rem;
  }
  .service-item h5 {
    font-size: 1.125rem;
  }
  .service-item p {
    font-size: 0.875rem;
  }
}

@media (max-width: 992px) {
  .fixed-grid {
    grid-template-columns: repeat(
      3,
      minmax(0, 1fr)
    ); /* Maintain three columns on smaller screens */
  }
  .service-item i {
    font-size: 2rem;
  }
  .service-item h5 {
    font-size: 1rem;
  }
  .service-item p {
    font-size: 0.75rem;
  }
}

@media (max-width: 768px) {
  .fixed-grid {
    grid-template-columns: repeat(
      3,
      minmax(0, 1fr)
    ); /* Maintain three columns on smaller screens */
  }
  .service-item i {
    font-size: 2rem;
  }
  .service-item h5 {
    font-size: 0.875rem;
  }
  .service-item p {
    font-size: 0.625rem;
  }

  .category-grid {
    grid-template-columns: 1fr; /* Switch to one column */
  }
}

@media (max-width: 576px) {
  .fixed-grid {
    grid-template-columns: repeat(
      3,
      minmax(0, 1fr)
    ); /* Maintain three columns on smaller screens */
  }
  .service-item i {
    font-size: 2rem;
  }
  .service-item h5 {
    font-size: 0.75rem;
  }
  .service-item p {
    font-size: 0.5rem;
  }
}

.share-button-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: -30px; /* Move it slightly into the panel */
  position: relative;
  z-index: 10;
}

.share-button-wrapper a {
  display: flex;
  align-items: center;
  margin-top: 3px;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: white;
  border-radius: 50%;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.5);
  transition: 0.3s ease-in-out;
}

.share-button-wrapper img {
  width: 30px;
  height: 30px;
  filter: invert(0.5); /* Darker icon */
}

/* Hover Effect */
.share-button-wrapper a:hover {
  background: #007bff;
}

.share-button-wrapper a:hover img {
  filter: invert(1); /* White icon on hover */
}

.resume-button {
  background: #f0f0f0; /* Light gray background */
  color: #8bc34a; /* Green text */
  font-family: "Poppins", "Nunito", "Montserrat", sans-serif; /* Use similar font */
  font-weight: bold; /* Bold text */
  font-size: 48px; /* Large font */
  padding: 15px 40px; /* Button padding */
  border-radius: 50px; /* Rounded button */
  border: none;
  display: inline-block;
  text-align: center;
  text-transform: uppercase; /* Capital letters */
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.2); /* Soft shadow */
  transition: 0.3s ease-in-out;
}

.resume-button:hover {
  background: #e0e0e0; /* Slightly darker on hover */
  color: #7caf3f; /* Darker green */
}

.start-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap; /* Ensures buttons stay in one line */
  gap: 10px; /* Adds spacing between buttons */
}

.btn-img {
  max-width: 100px; /* Adjust as needed */
  height: auto; /* Maintain aspect ratio */
}

@media (max-width: 768px) {
  .btn-img {
    max-width: 80px; /* Slightly smaller for mobile */
  }
}

button:disabled {
  opacity: 0.5 !important; /* Reduce opacity */
  cursor: not-allowed; /* Change cursor to indicate it's not clickable */
  filter: grayscale(100%); /* Convert to grey */
}

.completion-banner {
  top: -150px;
  max-width: 500px;
  margin: 0 auto;
  padding: 1rem;
  position: relative;
  border: 2px solid green;
  z-index: 99999999 !important;
  background-color: #f0fff0;
  border-radius: 10px;
}
.completion-banner p {
  font-family: "Myriad Pro", sans-serif;
  font-size: 1.2rem;
}

/* Pull the wavy separator up so its torn green edge overlaps the carousel image
   and no page background shows through the gap. Sep3.svg has ~40px of empty
   space (of its 241px height) above the torn edge, which scales with the
   viewport under background-size: cover - hence the vw-based pull, clamped so
   it stays sensible on very wide and very narrow screens. */
.full-width-image-section.trail-info.white-sep {
  margin-top: clamp(-96px, -5vw, -40px);
}

/* Keep the carousel dots clear of the separator now that it sits higher */
.carousel-indicators {
  bottom: 3rem;
}
</style>
